import { FC } from "react"
import { Lead } from "../../../../../../types"
import Accordion from "../../../../accordion"
import SectionCell from "../../../../section/cell"
import LoanScenario from "./accordion-sections/loan-scenario"
import PropertyLocation from "./accordion-sections/property-location"
import { formatPhoneNumber, formatDateTimeFromISO } from "../../../../../utils"
import Misc from "./accordion-sections/misc"
import Message from "./accordion-sections/message"
import If from "../../../../if"

interface Props {
  data: Lead
  cols?: number
  dashLink?: string
  openAccordionsByDefault?: boolean
}

const LeadSummary: FC<Props> = ({
  data,
  cols = 2,
  dashLink,
  openAccordionsByDefault = true
}) => (
  <div className="max-w-3xl">
    <div className={`grid grid-cols-${cols} gap-4`}>
      <SectionCell label="First name" value={data.first_name} />
      <SectionCell label="Last name" value={data.last_name} />
      <SectionCell label="Email address" value={data.email} />
      <SectionCell
        label="Phone number"
        value={formatPhoneNumber(data.phone ?? "")}
      />
      <SectionCell
        className="break-all"
        label="Created by"
        value={data.owner}
      />
      <SectionCell
        label="Created on"
        value={formatDateTimeFromISO(data.date_time)}
      />
      <If
        condition={!!dashLink}
        then={
          <div className="pt-6">
            <div className="pb-1 text-neutral-400">Dashboard link</div>
            <div className="text-neutral-900 h-7">
              <a href={dashLink} target="_blank" rel="noreferrer">
                {dashLink}
              </a>
            </div>
          </div>
        }
      />
    </div>

    <div className="mt-12">
      <div className="my-4">
        <Accordion
          title="Property location"
          openByDefault={openAccordionsByDefault}
        >
          <PropertyLocation cols={cols} data={data} />
        </Accordion>
      </div>
      <div className="my-4">
        <Accordion
          title="Loan scenario"
          openByDefault={openAccordionsByDefault}
        >
          <LoanScenario cols={cols} data={data} />
        </Accordion>
      </div>
      <div className="my-4">
        <Accordion title="Misc." openByDefault={openAccordionsByDefault}>
          <Misc cols={cols} data={data} />
        </Accordion>
      </div>
      <div className="my-4">
        <Accordion title="Message" openByDefault={openAccordionsByDefault}>
          <Message data={data} />
        </Accordion>
      </div>
    </div>
  </div>
)

export default LeadSummary
